var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editor)?_c('div',{staticClass:"editor"},[_c('MenuBar',{staticClass:"editor__header",attrs:{"editor":_vm.editor}}),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.editor}}),_c('div',{staticClass:"editor__footer"},[_vm._v(" "+_vm._s(_vm.wordsCount)+" words ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }